import { EScheduleType } from 'constants/enums';

export const SCHEDULE_TAB_TRIGGERS = [
    { value: EScheduleType.PERMANENT, label: 'Permanent' },
    { value: EScheduleType.SCHEDULED, label: 'Schedule' }
];

